<template>
  <b-row>
    <b-col sm="12">
      <b-card header="Listado de fallas">
        <div class="table-responsive">
          <div class="form-group form-inline pull-right">
            <input
              v-model="search"
              type="search"
              class="form-control"
              placeholder="Buscar Incidente"
            /> &nbsp;
          </div>
          <table class="table table-striped table-hover table-bordered">
            <thead>
              <tr>
                <th>Fecha</th>
                <th>Placa</th>
                <th>Conductor</th>
                <!-- <th>Partes con fallas</th> -->
                <th>Observaciones de Conductor</th>
                <th>Acción</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(incident, k) in paginated('filteredIncidents')" :key="k">
                <td>{{incident.created_at | formatDate}}</td>
                <td>{{incident.truck.plate}}</td>
                <td>{{incident.driver.name}} {{incident.driver.last_name}}</td>
                <!-- <td>
                  <div v-for="(item, j) in incident.items" :key="j">
                    <span class="badge badge-danger">{{item.name}}</span>
                  </div>
                </td>-->
                <td>{{incident.comments}}</td>
                <td>
                  <b-button
                    @click="openDetail(incident)"
                    type="button"
                    variant="primary"
                  >Ver detalle</b-button>&nbsp;
                  <b-button @click="createOt(incident)" type="button" variant="primary">Crear OT</b-button>
                </td>
              </tr>
            </tbody>
          </table>
          <DetailModal
            :showModal="showModal"
            :incident="selectedIncident"
            @close="showModal = false"
          />
          <div v-if="showModal" class="modal-backdrop fade show"></div>
          <paginate
            name="filteredIncidents"
            :list="filteredIncidents"
            class="paginate-list"
            :per="10"
          ></paginate>
          <paginate-links
            for="filteredIncidents"
            :limit="5"
            :show-step-links="true"
            :step-links="{
                next: '>>',
                prev: '<<'
              }"
            :classes="{
                'ul': 'pagination',
                'li': 'page-item',
                'a': 'page-link',
              }"
          ></paginate-links>
        </div>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
import api from "@/helpers/api";
import DetailModal from "./DetailModal";

export default {
  components: { DetailModal },
  data() {
    return {
      incidents: [],
      paginate: ["filteredIncidents"],
      search: "",
      selectedIncident: {},
      showModal: false
    };
  },
  mounted() {
    api.get("/incidents").then(response => {
      this.incidents = response.incidents;
      console.log(this.incidents);
    });
  },
  methods: {
    createOt(incident) {
      this.$router.push({
        path: `/fleet/maintenance/new/${incident.id}`
      });
    },
    openDetail(incident) {
      this.selectedIncident = incident;
      console.log(this.selectedIncident);
      this.showModal = true;
    }
  },
  computed: {
    filteredIncidents() {
      return this.incidents.filter(incident => {
        return this.search
          ? incident.truck.plate
              .toLowerCase()
              .includes(this.search.toLowerCase())
          : true;
      });
    }
  },
  sockets: {
    connect: function() {
      console.log("socket connected");
    },
    updateIncident: function(incident) {
      console.log(incident);
      const index = this.incidents.findIndex(r => r.id === incident.id);
      if (index >= 0) this.incidents.splice(index, 1, incident);
    },
    newIncident: function(incident) {
      this.incidents.unshift(incident);
    }
  }
};
</script>
